import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import withDidMountRequest from 'app/connectors/withDidMountRequest'

import { companyStatsData, isCompanyStatsDataEmpty, companyStatsPending } from 'store/entities/companyStats/selectors'
import { companyStatsRequest } from 'store/entities/companyStats/actions'
import CompanyDashboard from './CompanyDashboard'

const mapStateToProps = createStructuredSelector({
  pending: companyStatsPending,
  data: companyStatsData,
  isEmpty: isCompanyStatsDataEmpty,
})

const mapDispatchToProps = {
  onRequest: companyStatsRequest,
}

export default connect(mapStateToProps, mapDispatchToProps)(withDidMountRequest(CompanyDashboard))
